export default __webpack_public_path__ + "icon_play_hoverd8373c.svg";